export default __webpack_public_path__ + "static/media/shirtly_logo.77b9e36a.svg";